// src/pages/admin/AdminApplications.jsx
import { useEffect, useState } from 'react'
import { supabase } from '../../lib/supabaseClient'

export default function AdminApplications() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState({ status: 'All', q: '' })

  useEffect(() => { fetchAll() }, [])

  async function fetchAll() {
    setLoading(true)
    const { data, error } = await supabase
      .from('applications')
      .select('apply_id, post_id, pharmacist_name, contact, apply_date, status')
      .order('apply_id', { ascending: false })
    if (error) console.error(error)
    setRows(data || [])
    setLoading(false)
  }

  const filtered = rows.filter(r => {
    const byStatus = filter.status === 'All' ? true : (r.status === filter.status)
    const q = filter.q.trim().toLowerCase()
    const byQ = q
      ? `${r.pharmacist_name ?? ''} ${r.contact ?? ''} ${r.post_id ?? ''}`
        .toLowerCase()
        .includes(q)
      : true
    return byStatus && byQ
  })

  function exportCSV() {
    const header = ['apply_id', 'post_id', 'pharmacist_name', 'contact', 'apply_date', 'status']
    const body = filtered.map(r => [r.apply_id, r.post_id, r.pharmacist_name, r.contact, r.apply_date, r.status])
    const csv = [header, ...body].map(arr => arr.map(s => `"${(s ?? '').toString().replace(/"/g, '""')}"`).join(',')).join('\n')
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `applications_${new Date().toISOString().slice(0, 10)}.csv`
    a.click()
    URL.revokeObjectURL(url)
  }

  return (
    <div>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-lg font-semibold">🗂 지원 현황</h2>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full sm:w-auto">
          <select
            className="px-2 py-2 border rounded-md text-sm"
            value={filter.status}
            onChange={e => setFilter(f => ({ ...f, status: e.target.value }))}
          >
            <option>All</option>
            <option>Pending</option>
            <option>Approved</option>
            <option>Rejected</option>
          </select>
          <input
            className="px-2 py-2 border rounded-md text-sm w-full sm:w-48"
            placeholder="이름/연락처/공고ID 검색"
            value={filter.q}
            onChange={e => setFilter(f => ({ ...f, q: e.target.value }))}
          />
          <div className="flex gap-2">
            <button onClick={exportCSV} className="flex-1 sm:flex-none px-3 py-2 rounded-md border hover:bg-gray-50 text-xs sm:text-sm">CSV</button>
            <button onClick={fetchAll} className="flex-1 sm:flex-none px-3 py-2 rounded-md border hover:bg-gray-50 text-xs sm:text-sm">새로고침</button>
          </div>
        </div>
      </div>

      <ul className="mt-3 grid gap-2">
        {loading && <li className="h-20 rounded-xl bg-gray-50 animate-pulse" />}
        {!loading && filtered.length === 0 && <li className="text-sm text-gray-500">데이터가 없습니다.</li>}
        {!loading && filtered.map(r => (
          <li key={r.apply_id} className="rounded-xl border p-3">
            <div className="flex items-center justify-between">
              <div className="text-sm">
                <strong>지원자</strong> {r.pharmacist_name} · {r.contact || '연락처 없음'}
              </div>
              <div className="text-xs text-gray-600">
                공고 #{r.post_id} · {r.apply_date} · {r.status}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
